import { useCallback, useMemo } from 'react';
import { CATEGORY_TYPES } from '../constants/navigationConstants';

/**
 * Custom hook to manage category open/close handlers
 * Simplifies the logic for handling category state changes
 */
export const useCategoryHandlers = (navItems, setOpenCategory) => {
    const categoryOpenHandlers = useMemo(() => {
        if (!navItems) return {};
        
        return navItems.reduce((handlers, category) => {
            handlers[category.label] = () => setOpenCategory(prevCategory => 
                prevCategory === category.label ? null : category.label
            );
            return handlers;
        }, {});
    }, [navItems, setOpenCategory]);

    const favouritesOpenHandler = useCallback(() => {
        setOpenCategory(prevCategory => prevCategory === CATEGORY_TYPES.FAVORITES ? null : CATEGORY_TYPES.FAVORITES);
    }, [setOpenCategory]);

    const homeOpenHandler = useCallback(() => {
        setOpenCategory(prevCategory => prevCategory === CATEGORY_TYPES.HOME ? null : CATEGORY_TYPES.HOME);
    }, [setOpenCategory]);

    return { categoryOpenHandlers, favouritesOpenHandler, homeOpenHandler };
};
